import {TransportType, transportTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<TransportType>;

export const TransportTypeSelect = (props: Props) => {
  const {options = transportTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
